import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { TEXT_NAV_PATHS } from '../constants';
import Icon from '@/components/atoms/Icon';
import { classnames } from '@/libs/utils';
import { useAppContext } from '@/context/AppContext/AppContext';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

export default function TextNavItem() {
  const buttonRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const { theme } = useAppContext();

  const isActive = TEXT_NAV_PATHS.some(p => location.pathname.includes(`/${p}`));

  const handleClick = () => {
    if (isActive) {
      return;
    }
    if (buttonRef.current) {
      const { top } = buttonRef.current.getBoundingClientRect();
      EventBus.dispatch(CustomEvents.OpenTextNavPopup, { top, button: buttonRef.current });
    }
  };

  return (
    <div
      ref={buttonRef}
      onClick={handleClick}
      data-testid="text-nav-item"
      className={classnames({ '!mb-2': theme === 'goldcast' })}
    >
      <li className="group relative flex cursor-pointer flex-col items-center space-y-0.5">
        <div
          className={classnames('flex size-10 items-center justify-center rounded-lg', {
            'bg-gray-300': isActive,
            'group-hover:bg-slate-200': !isActive
          })}
        >
          <Icon
            name="IconTextSize"
            className={classnames('size-[18px]', {
              'text-black': isActive,
              'navigation-icon text-slate-600 group-hover:text-black': !isActive
            })}
          />
        </div>
        <span
          className={classnames('text-c3xs text-xs font-icons', {
            'text-black': isActive,
            'text-slate-600 group-hover:text-black': !isActive
          })}
        >
          Text
        </span>
      </li>
    </div>
  );
}
